// @ts-strict-ignore
import { ReportType } from 'constants/reports/report-type';
import { ApiManager } from 'services/api/api-manager';
import { serializeReportDistribution } from 'services/api/report/v3/filters';
import { type IActionWithPayload } from 'store/helper';

import { staticReportFilters } from '../constants/static-filters';
import {
  type IFetchReportPayload,
  type IReportRequest,
  ReportRequestName,
  RequestVersion,
  type IFetchReportOptions,
} from '../interfaces';

import { makeFetchingSaga } from './helpers';

export function* fetchChatDuration(action: IActionWithPayload<string, IFetchReportPayload>) {
  const requests: IReportRequest[] = [
    {
      version: RequestVersion.V3,
      name: ReportRequestName.ChatDuration,
      interface: ApiManager.reportApiV3.fetchChatDuration,
      extendedFilters: staticReportFilters[ReportType.ChatDuration],
    },
  ];

  const options: IFetchReportOptions = {
    apiFiltersSerializer: serializeReportDistribution,
  };

  yield makeFetchingSaga(ReportType.ChatDuration, action, requests, options);
}
